import { RoutalPalette } from '@nx-smartmonkey/ui';
import { animated, useSpring } from '@react-spring/web';
import { PropsWithChildren } from 'react';

import { Grid } from '@mui/material';
import { createPortal } from 'react-dom';
import BackArrowIcon from '../../../assets/svg/BackArrowIcon';
import { DRIVERS_LAYOUT_ID } from '../../../components/DriversLayout';

interface BackButtonProps {
  onPreviousStep: () => void;
  color?: string;
}

const BackButton = ({ onPreviousStep, color = RoutalPalette.primary40 }: BackButtonProps) => {
  const content = (
    <Grid position="absolute" top="24px" left="24px" onClick={onPreviousStep}>
      <BackArrowIcon color={color} style={{ height: `32px`, width: `32px` }} />
    </Grid>
  );

  const element = document.getElementById(DRIVERS_LAYOUT_ID ?? ``);
  if (element) {
    return createPortal(content, element as HTMLElement);
  }

  return content;
};

interface AuthContentWrapperProps {
  fullScreen?: boolean;
  backButtonColor?: string;
  onPreviousStep?: () => void;
}

export const AuthContentWrapper = ({
  fullScreen,
  onPreviousStep,
  backButtonColor,
  children,
}: PropsWithChildren<AuthContentWrapperProps>) => {
  const enterAnimationHeight = useSpring({
    top: fullScreen ? `0%` : `40%`,
  });
  const enterAnimationBorderRadius = useSpring({
    borderRadius: fullScreen ? `0px 0px 0 0` : `30px 30px 0 0`,
    delay: 250,
  });

  const enterAnimationPaddingTop = useSpring({
    paddingTop: fullScreen ? `60px` : `32px`,
  });

  return (
    <animated.div
      style={{
        position: `absolute`,
        display: `flex`,
        flexDirection: `column`,
        inset: 0,
        bottom: 0,
        backgroundColor: RoutalPalette.primary60,
        ...enterAnimationHeight,
      }}
    >
      <animated.div
        style={{
          height: `100%`,
          display: `flex`,
          flexDirection: `column`,
          alignItems: `center`,
          position: `relative`,
          backgroundColor: RoutalPalette.neutral02n,
          paddingRight: `28px`,
          paddingBottom: `32px`,
          paddingLeft: `28px`,
          ...enterAnimationPaddingTop,
          ...enterAnimationBorderRadius,
        }}
      >
        {onPreviousStep && <BackButton onPreviousStep={onPreviousStep} color={backButtonColor} />}
        {children}
      </animated.div>
    </animated.div>
  );
};
